import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import slide_one from '../../Assets/images/slide_one.jpg';
import slide_two from '../../Assets/images/slide_two.jpg';
import slide_three from '../../Assets/images/slide_three.jpg';

const Carousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    autoplaySpeed: 4500,
    autoplay: true,
  };

  return (
    <div
      className='carrousel_wrapper'
      style={{ height: `${window.innerHeight}px` }}
    >
      <Slider {...settings}>
        <div>
          <div
            className='carrousel_image'
            style={{
              background: `url(${slide_one})`,
              height: `${window.innerHeight}px`,
            }}
          ></div>
        </div>
        <div>
          <div
            className='carrousel_image'
            style={{
              background: `url(${slide_two})`,
              height: `${window.innerHeight}px`,
            }}
          ></div>
        </div>
        <div>
          <div
            className='carrousel_image'
            style={{
              background: `url(${slide_three})`,
              height: `${window.innerHeight}px`,
            }}
          ></div>
        </div>
      </Slider>
    </div>
  );
};

export default Carousel;
